<template>
    <div>
        <div id="FormList">
            <div class="header">
                <div class="header-logo">
                    <span class="md-icon">document_scanner</span>
                </div>
                <div class="header-text">
                    <h1>Formlar</h1>
                    <p>Formlarınızı buradan yönetebilirsiniz.</p>
                </div>
            </div>
            <div class="container">
                <div
                    class="list-card"
                    v-for="form in formsWithColors"
                    :key="form._id"
                    :style="{ borderLeftColor: form.color }"
                    @click="formId(form._id)"
                >
                    <div class="icon-section" :style="{ backgroundColor: form.color }">
                        <i class="md-icon">text_snippet</i>
                    </div>
                    <div class="text-section">
                        <div class="title">{{ form.title }}</div>
                    </div>
                    <div class="arrow-section">
                        <div style="position: relative; display: inline-block;">
                            <i
                                class="md-icon"
                                style="color: mediumseagreen"
                                @click="editForm(form._id)"
                                v-tippy="{ content: 'Düzenle', placement: 'top' }"
                            >
                                edit
                            </i>
                        </div>
                        <div style="position: relative; display: inline-block;" @click="inboxForm(form._id)">
                            <i
                                class="md-icon"
                                style="color: cornflowerblue"
                                v-tippy="{ content: 'Gelen Kutusu', placement: 'top' }"
                            >
                                inbox
                            </i>
                            <span class="badge"
                                  v-if="answerTotal[form._id] && answerTotal[form._id].notRead">{{ answerTotal[form._id].notRead
                                }}</span>
                            <span class="badge" v-else>0</span>
                        </div>
                        <div style="position: relative; display: inline-block;">
                            <i
                                class="md-icon"
                                style="color: orangered"
                                @click="formDelete(form)"
                                v-tippy="{ content: 'Sil', placement: 'top' }"
                            >
                                delete
                            </i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info-box" :style="{ borderRightColor: selectedFormColor }">
            <div :style="{ borderBottomColor: selectedFormColor }">
                {{ selectedForm ? selectedForm.title : "" }}
            </div>
            <div>
                Toplam Yanıt: {{ selectedFormAnswerTotal }}
            </div>
            <div>
                Toplam Okunmamış Yanıt: {{ selectedFormNotReadTotal }}
            </div>
            <div>
                Toplam Okunmuş Yanıt: {{ selectedFormReadTotal }}
            </div>
            <div>
                Toplam Arşivlenmiş Yanıt: {{ selectedFormArchiveTotal }}
            </div>
            <div class="button-group">
                <button @click="viewForm(selectedForm._id)" :style="{ backgroundColor: selectedFormColor }">
                    Formu Görüntüle
                </button>
                <button @click="editForm(selectedForm._id)" :style="{ backgroundColor: selectedFormColor }">
                    Formu Düzenle
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "FormList",
    data() {
        return {
            type: "default",
            answerTotal: {},
            selectedForm: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            forms: (state) => state.forms.forms,
            form: (state) => state.forms.form,
        }),
        formsWithColors() {
            return this.forms.map(form => {
                return {
                    ...form,
                    color: this.getRandomColor(form.form_slug),
                };
            });
        },
        selectedFormColor() {
            return this.selectedForm ? this.getRandomColor(this.selectedForm.form_slug) : "rgb(255, 179, 153)";
        },
        selectedFormAnswerTotal() {
            return this.selectedForm ? (this.answerTotal[this.selectedForm._id]?.read || 0) + (this.answerTotal[this.selectedForm._id]?.notRead || 0) + (this.answerTotal[this.selectedForm._id]?.archive || 0) : 0;
        },
        selectedFormReadTotal() {
            return this.selectedForm ? this.answerTotal[this.selectedForm._id]?.read || 0 : 0;
        },
        selectedFormNotReadTotal() {
            return this.selectedForm ? this.answerTotal[this.selectedForm._id]?.notRead || 0 : 0;
        },
        selectedFormArchiveTotal() {
            return this.selectedForm ? this.answerTotal[this.selectedForm._id]?.archive || 0 : 0;
        },
    },
    methods: {
        ...mapActions({
            getListForm: "forms/getListForm",
            getForm: "forms/getForm",
            deleteForm: "forms/deleteForm",
            getFormAnswers: "forms/getFormAnswers",
            getFormAnswerTotal: "forms/getFormAnswerTotal",
        }),
        getRandomColor(seed) {
            const colors = [
                "#8B0000", "#A52A2A", "#800000", "#2F4F4F", "#556B2F",
                "#8B4513", "#483D8B", "#2E8B57", "#4682B4", "#6A5ACD",
                "#4B0082", "#708090", "#696969", "#808080", "#2F4F4F",
                "#3CB371", "#8B008B", "#9932CC", "#8B0000", "#8B4513",
                "#2E8B57", "#556B2F", "#6A5ACD", "#483D8B", "#4B0082",
                "#2F4F4F", "#696969", "#708090", "#808080", "#8B0000",
                "#A52A2A", "#800000", "#2F4F4F", "#556B2F", "#8B4513",
                "#483D8B", "#2E8B57", "#4682B4", "#6A5ACD", "#4B0082",
                "#708090", "#696969", "#808080", "#2F4F4F", "#3CB371",
            ];
            let hash = 0;
            for (let i = 0; i < seed.length; i++) {
                hash = seed.charCodeAt(i) + ((hash << 5) - hash);
            }
            return colors[Math.abs(hash) % colors.length];
        },
        async fetchForms() {
            await this.getListForm(this.site._id);
            if (this.forms.length > 0) {
                this.selectedForm = this.forms[0];
            }
        },
        formId(formId) {
            this.selectedForm = this.forms.find(form => form._id === formId);
        },
        async editForm(formId) {
            this.$router.push("form/build/" + formId);
        },
        async inboxForm(form) {
            this.$router.push({
                path: `/form/inbox/${form}`,
            });
            const formAnswers = await this.getFormAnswers({ siteId: this.site._id, formId: form });
            console.log("inbox form:", formAnswers);
        },
        async formDelete(form) {
            console.log("gelenveriii", form);
            await this.deleteForm({ siteId: this.site._id, formId: form._id });
            this.fetchForms();
        },
        async totalAnswer(formId) {
            const total = await this.getFormAnswerTotal({
                siteId: this.site._id,
                formId: formId,
                status: "notRead",
            });
            this.$set(this.answerTotal, formId, total);
        },
        async fetchAnswerTotals() {
            for (const form of this.forms) {
                await this.totalAnswer(form._id);
            }
        },
        viewForm(formId) {
            window.open(`https://form.supsis.ai/form/${formId}/${this.site._id}`, "_blank");
        },
    },
    async created() {
        await this.fetchForms();
    },
    watch: {
        forms: {
            handler: "fetchAnswerTotals",
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
#FormList {
    position: fixed;
    width: 70%;
    z-index: 99;
    .header {
        display: flex;
        align-items: center;
        padding: 20px;
        background-color: #f5f7fa;
        border-bottom: 2px solid #e0e0e0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        margin: 20px;

        .header-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            margin-right: 20px;

            .md-icon {
                font-size: 24px;
                color: #333;
            }
        }

        .header-text {
            display: flex;
            flex-direction: column;
            justify-content: center;

            h1 {
                font-size: 24px;
                font-weight: 600;
                color: #333;
                margin: 0;
            }

            p {
                font-size: 14px;
                color: #666;
                margin: 5px 0 0;
            }
        }
    }

    .container {
        height: 700px;
        overflow: scroll;
        padding-bottom: 200px;

        .list-card {
            display: flex;
            align-items: center;
            background-color: #ffff;
            border: 1px solid #dcdcdc;
            border-radius: 8px;
            padding: 1rem;
            width: 100%;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: box-shadow 0.3s;
            border-left: 5px solid;
            cursor: pointer;
            margin-bottom: 10px;

            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            }

            .icon-section {
                padding: 1rem;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 1rem;

                i {
                    color: #fff;
                    font-size: 2rem;
                }
            }

            .text-section {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .title {
                    font-weight: bold;
                    font-size: 1.25rem;
                    color: #1f224f;
                }
            }

            .arrow-section {
                display: flex;
                justify-content: center;
                align-items: center;

                i {
                    font-size: 1.5rem;
                    color: #666;
                    margin-left: 10px;
                    cursor: pointer;
                    transition: color 0.3s;

                    &:hover {
                        color: #333;
                    }
                }

                .badge {
                    position: absolute;
                    top: -7px;
                    right: -6px;
                    background-color: red;
                    color: white;
                    border-radius: 50%;
                    padding: 5px 10px;
                    font-size: 8px;
                    font-weight: bold;
                    width: 2px;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                }
            }
        }
    }
}

.info-box {
    position: absolute;
    right: 10px;
    top: 23px;
    width: 20%;
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-right: 5px solid;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 300px;

    div {
        padding: 10px;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        border-bottom: 1px solid #e0e0e0;

        &:last-child {
            border-bottom: none;
        }
    }

    div:first-child {
        font-size: 20px;
        font-weight: bold;
        color: #1f224f;
        //border-bottom: 2px solid #ffb399;
    }

    div:nth-child(2), div:nth-child(3), div:nth-child(4), div:nth-child(5) {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            background-color: #ffb399;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: white;
            font-weight: bold;
        }
    }

    .button-group {
        display: flex;
        justify-content: space-between;
        align-items: center;

        button {
            width: 109px;
            background-color: rgb(255, 179, 153);
            font-size: 9px;
            margin: 5px;
            color: white;
            font-weight: bold;
            border: none;
            border-radius: 6px;
            padding: 10px 20px;
            cursor: pointer;
            -webkit-transition: background-color 0.3s ease;
            transition: background-color 0.3s ease;
        }
    }
}
</style>
